<template lang="pug">
v-checkbox(
  v-model="inputValue"
  v-bind="attrs"
  v-on="$listeners"
)
  template(
    v-for="(_, name) in $scopedSlots"
    v-slot:[name]="data"
  )
    slot(
      :name="name"
      v-bind="data"
    )
  template(
    v-for="(_, name) in $slots"
    :slot="name"
  )
    slot(:name="name")
</template>

<script>
export default {
  name: 'AppCheckbox',
  components: {},
  props: {
    value: {
      type: [Boolean, Number, String, Object, Array],
      default: () => null,
    },
  },
  data() {
    return {};
  },
  computed: {
    inputValue: {
      get() {
        return this.value;
      },
      set(value) {
        this.$emit('input', value);
      },
    },
    attrs() {
      return {
        color: 'redesignPrimary',
        'hide-details': 'auto',
        'on-icon': '$icheckbox-on',
        'off-icon': '$icheckbox-off',
        ...this.$attrs,
      };
    },
  },
  watch: {},
  created() {},
  methods: {},
};
</script>

<style scoped lang="scss">
::v-deep.v-input {
  &--checkbox {
    &.v-input--selection-controls {
      margin-top: 0;
      padding-top: 0;
    }
  }

  &--dense {
    &.v-input--selection-controls {
      margin-top: 0;
      padding-top: 0;
    }
  }
}
</style>
